var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 10.7346C31.1167 4.98463 26.0667 0.667969 20 0.667969C15.1833 0.667969 11 3.4013 8.91667 7.4013C3.9 7.93463 0 12.1846 0 17.3346C0 22.8513 4.48333 27.3346 10 27.3346H31.6667C36.2667 27.3346 40 23.6013 40 19.0013C40 14.6013 36.5833 11.0346 32.25 10.7346ZM23.3333 15.668V22.3346H16.6667V15.668H11.6667L20 7.33463L28.3333 15.668H23.3333Z",
    fill: "#eb672d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadFile);
export default __webpack_public_path__ + "static/media/IconUploadFile.f70e00119f49db56b7eeddb0b475d273.svg";
export { ForwardRef as ReactComponent };